import User from 'src/models/user';

export const Users: User[] = [
  {
    id: 1,
    name: 'Michele Tognetti',
    email: 'ufficiotecnico@btsolutions.it',
    yard_id: 0,
    is_admin: 1,
    is_super_admin: 0,
  },
  {
    id: 4,
    name: 'Fabrizio Grasso',
    email: 'fabrizio.grasso@rina.org',
    yard_id: 2,
    is_admin: 0,
    is_super_admin: 1,
  },
  {
    id: 5,
    name: 'Andrew Cutri',
    email: 'andrew.cutri@rina.org',
    yard_id: 2,
    is_admin: 0,
    is_super_admin: 1,
  },
  {
    id: 8,
    name: 'Mattia Mestice',
    email: 'mattia.mestice@azimutyachts.net',
    yard_id: 1,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 7,
    name: 'Massimo Bassi',
    email: 'massimo.bassi@azimutyachts.net',
    yard_id: 1,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 37,
    name: 'Danilo Sammartano',
    email: 'd.sammartano@carbonovus.it',
    yard_id: 11,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 10,
    name: 'Gabriele Martinelli',
    email: 'gabriele.martinelli@azimutyachts.net',
    yard_id: 1,
    is_admin: 0,
    is_super_admin: 1,
  },
  {
    id: 16,
    name: 'Matteo Zurli',
    email: 'mzurli@eagle.org',
    yard_id: 5,
    is_admin: 0,
    is_super_admin: 1,
  },
  {
    id: 17,
    name: 'Massimo Pardini',
    email: 'massimo.pardini@azimutyachts.net',
    yard_id: 1,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 18,
    name: 'Filippo Bernardini',
    email: 'filippo.bernardini@benettiyachts.it',
    yard_id: 4,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 19,
    name: 'David Giuliani',
    email: 'david.giuliani@rina.org',
    yard_id: 2,
    is_admin: 0,
    is_super_admin: 1,
  },
  {
    id: 20,
    name: 'Andrea Piccioli',
    email: 'andrea.piccioli@tubinavi.it',
    yard_id: 6,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 21,
    name: 'Mauro Aglietti',
    email: 'mauro.aglietti@azimutbenettigroup.com',
    yard_id: 4,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 22,
    name: 'Claudio Galeotti',
    email: 'claudio.galeotti80@gmail.com',
    yard_id: 7,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 39,
    name: 'Massimo Angelotti',
    email: 'm.angelotti@sanlorenzoyacht.com',
    yard_id: 3,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 28,
    name: 'Mirko Marani',
    email: 'Mirko.marani@lusben.com',
    yard_id: 8,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 29,
    name: 'Alessandro Masini',
    email: 'teamcup@treemmei.com',
    yard_id: 9,
    is_admin: 0,
    is_super_admin: 1,
  },
  {
    id: 30,
    name: 'Gianluca Maggiorelli',
    email: 'gianluca.maggiorelli@lusben.com',
    yard_id: 8,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 31,
    name: 'Mario Dongu',
    email: 'mario@ypsolver.com',
    yard_id: 8,
    is_admin: 0,
    is_super_admin: 0,
  },
  {
    id: 34,
    name: 'Filippo Giubasso',
    email: 'filippo.giubasso@azimutbenetti.com',
    yard_id: 1,
    is_admin: 0,
    is_super_admin: 0,
  },
];
